import {
  RESUME_COURSE_STREAM,
  resolveSelectedCourseStream,
} from "../StudyDashboard/utils/resumeCourseFilter";

export const MISTAKE_BOOK_SUBJECTS_JEE = [
  { id: "physics", name: "Physics" },
  { id: "chemistry", name: "Chemistry" },
  { id: "maths", name: "Maths" },
];

export const MISTAKE_BOOK_SUBJECTS_NEET = [
  { id: "physics", name: "Physics" },
  { id: "chemistry", name: "Chemistry" },
  { id: "biology", name: "Biology" },
];

export const getMistakeBookSubjectsForCourse = ({
  targetId,
  targetName,
} = {}) => {
  const stream = resolveSelectedCourseStream({ targetId, targetName });
  if (stream === RESUME_COURSE_STREAM.NEET) {
    return MISTAKE_BOOK_SUBJECTS_NEET;
  }
  return MISTAKE_BOOK_SUBJECTS_JEE;
};
